import getFieldRecursive from './getFieldRecursive';
import isAlias from './isAlias';

/**
 * @param root - root object to start resolving fields from
 * @param separator - separator used in alias `ex. if it's "core/spacing/1x" then separator will be `/`
 * @returns object with resolved alias fields
 */
const resolveAliases = (
  root: Record<string, unknown>,
  separator = '/',
): Record<string, unknown> => {
  const resolveRecursive = (field: any): any => {
    if (typeof field !== 'object' || field === null || Array.isArray(field)) {
      return field;
    }

    const result: Record<string, unknown> = {};

    for (const key in field) {
      const value = field[key];

      if (isAlias(value, separator)) {
        result[key] = getFieldRecursive(root, value, separator);
      } else {
        result[key] = resolveRecursive(value);
      }
    }

    return result;
  };

  return resolveRecursive(root);
};

export default resolveAliases;
